import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import Form from 'erpcore/components/Form';
import Button from 'erpcore/components/Button';
import Svg from 'erpcore/components/Svg';
import Tooltip from 'erpcore/components/Tooltip';
import Modal from 'erpcore/components/Modal';
import { actions as eventActions } from 'erpcore/screens/Events/Events.reducer';

const EventStop = ({ id, handleSubmit, submitting, eventName, callback, endedAt }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const eventIri = `api/events/${id}`;

    const handleModal = () => {
        setOpened(!opened);
    };

    const endEvent = () => {
        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: eventActions.END_EVENT,
                eventIri
            })
        )
            .then(() => {
                callback();
            })
            .catch(error => {
                return error;
            })
            .finally(() => {
                handleModal();
            });
    };

    const completeEvent = () => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: eventActions.COMPLETE_EVENT,
                promise: { resolve, reject },
                eventIri
            });
        })
            .then(() => {
                callback();
            })
            .catch(error => {
                return error;
            })
            .finally(() => {
                handleModal();
            });
    };

    const renderLabel = () => (endedAt ? 'Complete event' : 'End event');
    const renderIcon = () => (endedAt ? 'completeEvent' : 'endEvent');
    return (
        <Fragment>
            <Tooltip content={renderLabel()}>
                <button type="button" onClick={handleModal}>
                    <Svg icon={renderIcon()} />
                </button>
            </Tooltip>
            {opened && (
                <Modal
                    variation="small"
                    opened={opened}
                    onClose={handleModal}
                    title={renderLabel()}
                    subtitle={
                        <>
                            Are you sure you want to {renderLabel()?.toLowerCase()}{' '}
                            <strong>{eventName}</strong>?
                        </>
                    }
                >
                    <Form onSubmit={handleSubmit(endedAt ? completeEvent : endEvent)}>
                        <Button submit loading={submitting} label={renderLabel()?.split(' ')[0]} />
                        <Button variation="secondary" label="Cancel" onClick={handleModal} />
                    </Form>
                </Modal>
            )}
        </Fragment>
    );
};

EventStop.defaultProps = {
    submitting: false,
    id: null,
    eventName: null,
    callback: () => {}
};

EventStop.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    endedAt: PropTypes.string.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    eventName: PropTypes.string,
    callback: PropTypes.func
};

export default reduxForm({
    form: 'CustomerDeleteForm',
    enableReinitialize: true
})(EventStop);
